import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ContractStateDto, ContractStatusDto, useListContractsQuery } from "../../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../../common/auth/useLoggedInWithOrgContextState";
import { useDisplayDate } from "../../../../common/formatting/useDisplayDate";
import { urls } from "../../../../urls";
import { HomePanel } from "./HomePanel";
import { MutedCell, PanelRow, PanelTable, TitleCell } from "./PanelTable";

export const ActiveContractsPanel = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const displayDate = useDisplayDate();
  const authState = useLoggedInWithOrgContextState();
  const { data, isLoading, isError } = useListContractsQuery({
    orgId: authState.selectedOrg.id,
    state: ContractStateDto.Published,
    statuses: [ContractStatusDto.Active, ContractStatusDto.Awarded].join(","),
    limit: 6,
  });
  const contracts = data?.contracts ?? [];

  return (
    <HomePanel titleKey="Active agreements" seeAllTo={urls.v2.contracts.active} isLoading={isLoading} isError={isError} isEmpty={contracts.length === 0} emptyKey="No active contracts">
      <PanelTable headers={[t("Title"), t("End date")]}>
        {contracts.map((c) => (
          <PanelRow key={c.id} onClick={() => navigate(urls.v2.contracts.view.go(c.id))}>
            <TitleCell title={c.title || t("Untitled")} />
            <MutedCell>{c.endDate ? displayDate(c.endDate) : "—"}</MutedCell>
          </PanelRow>
        ))}
      </PanelTable>
    </HomePanel>
  );
};
